"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/formFieldWrapper/index.ts
var formFieldWrapper_exports = {};
__export(formFieldWrapper_exports, {
  default: () => FormFieldWrapper_default
});
module.exports = __toCommonJS(formFieldWrapper_exports);
var import_index = require("./index.css");

// src/formFieldWrapper/FormFieldWrapper.tsx
var import_classnames2 = __toESM(require("classnames"));

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/formFieldWrapper/formFieldWrapper.module.scss
var formFieldWrapper_module_default = {
  "heading-xxl": "formFieldWrapper-module__heading-xxl___4CLqw",
  "heading-xl": "formFieldWrapper-module__heading-xl___eyqwq",
  "heading-lg": "formFieldWrapper-module__heading-lg___MLrX9",
  "heading-md": "formFieldWrapper-module__heading-md___f8a7H",
  "heading-sm": "formFieldWrapper-module__heading-sm___6kNRL",
  "heading-xs": "formFieldWrapper-module__heading-xs___GWC7M",
  "body-one": "formFieldWrapper-module__body-one___I4bPJ",
  "body-two": "formFieldWrapper-module__body-two___Zrpf5",
  "body-three": "formFieldWrapper-module__body-three___p0-8i",
  "body-four": "formFieldWrapper-module__body-four___feQQF",
  "overline-one": "formFieldWrapper-module__overline-one___Hrmh4",
  "overline-two": "formFieldWrapper-module__overline-two___P-L0I",
  "overline-three": "formFieldWrapper-module__overline-three___zbC04",
  "strong": "formFieldWrapper-module__strong___8BxXJ",
  "extra-strong": "formFieldWrapper-module__extra-strong___18BOS",
  "em": "formFieldWrapper-module__em___ZYLTg",
  "figcaption": "formFieldWrapper-module__figcaption___IB24m",
  "formFieldWrapper": "formFieldWrapper-module__formFieldWrapper___wa6RZ",
  "formFieldWrapperHelper": "formFieldWrapper-module__formFieldWrapperHelper___Di0P2",
  "formFieldWrapper-color-black": "formFieldWrapper-module__formFieldWrapper-color-black___9yNzp",
  "formFieldWrapperLabel": "formFieldWrapper-module__formFieldWrapperLabel___4tTzn",
  "formFieldWrapper-color-gray": "formFieldWrapper-module__formFieldWrapper-color-gray___pzU0N",
  "formFieldWrapperError": "formFieldWrapper-module__formFieldWrapperError___BI6Tj",
  "formFieldWrapper-color-white": "formFieldWrapper-module__formFieldWrapper-color-white___lY8Jq",
  "formFieldWrapper-size-l": "formFieldWrapper-module__formFieldWrapper-size-l___qnrHw",
  "formFieldWrapper-size-m": "formFieldWrapper-module__formFieldWrapper-size-m___2Q3pW",
  "formFieldWrapper-size-s": "formFieldWrapper-module__formFieldWrapper-size-s___uQOGl"
};

// src/formFieldWrapper/FormFieldWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var FormFieldWrapper = ({
  children,
  className,
  label,
  helperMessage,
  helperIcon,
  errorMessage,
  color = "black",
  size = "m",
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
  "label",
  {
    className: (0, import_classnames2.default)(
      formFieldWrapper_module_default.formFieldWrapper,
      formFieldWrapper_module_default[`formFieldWrapper-color-${color}`],
      formFieldWrapper_module_default[`formFieldWrapper-size-${size}`],
      className
    ),
    ...HTMLAttributes,
    children: [
      label && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: formFieldWrapper_module_default.formFieldWrapperLabel, children: label }),
      children,
      !errorMessage && helperMessage && /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: formFieldWrapper_module_default.formFieldWrapperHelper, children: [
        helperIcon && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...helperIcon }),
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { children: helperMessage })
      ] }),
      errorMessage && /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
        "div",
        {
          className: (0, import_classnames2.default)(
            formFieldWrapper_module_default.formFieldWrapperHelper,
            formFieldWrapper_module_default.formFieldWrapperError
          ),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { iconName: "circle-exclamation" }),
            /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { children: errorMessage })
          ]
        }
      )
    ]
  }
);
var FormFieldWrapper_default = FormFieldWrapper;
//# sourceMappingURL=index.js.map